import { cn } from 'noddi-ui-common';
import { type LayoutContainerWidth, layoutGutterVariants, navMaxWidthVariants } from 'noddi-ui-web';
import { ImpersonatingBanner, useAuthContext, useBookingActions } from 'noddi-web';
import { PropsWithChildren } from 'react';
import { useOnImpersonated } from '../../hooks/useOnImpersonated';
import { useCurrentBrand } from '../../stores/BrandStore/brandStore';

type NavWrapperProps = PropsWithChildren<{ width?: LayoutContainerWidth }>;

export const NavWrapper = ({ children, width = 'lg' }: NavWrapperProps) => {
  const { impersonatedUser } = useAuthContext();
  const { clearStore } = useBookingActions();
  const onImpersonated = useOnImpersonated();
  const { currentBrand } = useCurrentBrand();
  return (
    <>
      {!!impersonatedUser && (
        <ImpersonatingBanner
          onStopImpersonating={clearStore}
          onImpersonated={onImpersonated}
          defaultBrandDomain={currentBrand}
        />
      )}
      <div className={layoutGutterVariants({ width })}>
        <header
          className={cn(
            navMaxWidthVariants({ width }),
            'relative top-4 mb-4 flex h-14 items-center pr-2 pl-4',
            'md:top-5 md:mb-5 md:h-17 md:pr-3 md:pl-6',
            'rounded-[20px] border border-white/70 bg-white/[0.62]',
            // eslint-disable-next-line tailwindcss/no-unnecessary-arbitrary-value -- fixer emits an invalid dotted class
            'shadow-[0_1px_0_rgba(255,255,255,0.6)_inset,0_6px_20px_-14px_rgba(0,0,0,0.12)] backdrop-blur-[20px] backdrop-saturate-[1.4]',
            'supports-[not_(backdrop-filter:blur(1px))]:bg-white/[0.92]'
          )}
        >
          {children}
        </header>
      </div>
    </>
  );
};
